import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Application } from '../models/application/application';
import { ApplicationSendResponse } from '../models/application/applicationSendResponse';
import { BaseService } from './base.service';
import { FormService } from './form.service';
import { MembersService } from './members.service';
import { CheckoutModel } from '../models/application/paymentOptions';
import { ApiVersions } from './api-version';
import { PersonDetailsWrite } from 'src/app/people/models/personDetailsWrite';
import { IPaymentPreview } from '../models/application/applicationSubmit';

@Injectable()
export class ApplicationService extends BaseService {
  private basePath: string = 'applications';

  constructor(private formService: FormService, private membersService: MembersService) {
    super();
  }

  getBySecureLinkId(id: string): Observable<Application> {
    let path = `${this.basePath}/bySecureLink/${id}/request`;
    return this.get(path, true).pipe(
      map((data) => {
        let application = Application.parse(data);
        if (!application) {
          return null;
        }
        this.formService.setNext(application.form);
        this.membersService.workspaceLogoUrl.next(application.form.workspaceLogoUrl);
        this.membersService.workspaceHelpLink.next(application.form.workspaceHelpLink);
        return application;
      })
    );
  }

  getCheckoutOptions = (id: string, paymentPreview: IPaymentPreview): Promise<CheckoutModel> =>
    this.post(
      `${this.basePath}/bySecureLink/${id}/paymentOptions`,
      paymentPreview,
      null,
      ApiVersions.v0_1,
      true
    ).toPromise();

  getCheckoutOptionsForPreview = (
    id: string,
    paymentPreview: IPaymentPreview
  ): Promise<CheckoutModel> =>
    this.post(
      `${this.basePath}/${id}/preview/paymentOptions`,
      paymentPreview,
      null,
      ApiVersions.v0_1,
      true
    ).toPromise();

  getForPreview(id: string): Observable<Application> {
    let path = `${this.basePath}/${id}/preview`;
    return this.get(path).pipe(
      map((data) => {
        let application = Application.parse(data);
        this.membersService.workspaceLogoUrl.next(application.form.workspaceLogoUrl);
        return application;
      })
    );
  }

  sendBulkApplications(
    personIds: string[],
    formId: string,
    sendAll: boolean = true,
    sendNew: boolean = true,
    sendReminder: boolean = true
  ): Observable<any> {
    let body = JSON.stringify({
      formId: formId,
      personIds: personIds,
      sendAll: sendAll,
      sendNew: sendNew,
      sendReminder: sendReminder,
    });
    let path = `${this.basePath}/send/bulk`;
    return this.post(path, body);
  }
  bulkApplicationsDryRun(
    personIds: string[],
    formId: string,
    sendAll: boolean = true,
    sendNew: boolean = true,
    sendReminder: boolean = true
  ): Observable<ApplicationSendResponse> {
    let body = JSON.stringify({
      formId: formId,
      personIds: personIds,
      sendAll: sendAll,
      sendNew: sendNew,
      sendReminder: sendReminder,
    });
    let path = `${this.basePath}/send/bulk-dry-run`;
    return this.post(path, body).pipe(map(ApplicationSendResponse.parse));
  }
}
